import errorIcon from 'assets/images/interface/icon-interface-error-triangle-small.svg';
import infoIcon from 'assets/images/interface/icon-interface-info-small.svg';
import searchIcon from 'assets/images/interface/icon-interface-search-small.svg';
import successIcon from 'assets/images/interface/icon-interface-success-circle-small.svg';
import {Colors} from 'styles/Colors';

type BannerTheme = 'gray' | 'red' | 'green';

interface BannerThemeStyles {
  background: string | Colors;
  border: string | Colors;
  text: Colors;
}

const Themes: Record<BannerTheme, BannerThemeStyles> = {
  gray: {
    background: '#f6f6f4',
    border: Colors.LIGHT_GREY,
    text: Colors.NEAR_BLACK
  },
  red: {
    background: Colors.FAINT_RED,
    border: Colors.LIGHT_RED,
    text: Colors.WARNING_RED
  },
  green: {
    background: Colors.FAINT_GREEN,
    border: Colors.LIGHT_GREEN,
    text: Colors.SUCCESS_GREEN
  }
};

export type BannerType = 'info' | 'search' | 'error' | 'success';

interface BannerTypeAppearance {
  styles: BannerThemeStyles;
  icon: string;
}

export const BannerTypes: Record<BannerType, BannerTypeAppearance> = {
  info: {styles: Themes.gray, icon: infoIcon},
  search: {styles: Themes.gray, icon: searchIcon},
  error: {styles: Themes.red, icon: errorIcon},
  success: {styles: Themes.green, icon: successIcon}
};
